import React from 'react';
import { ShieldCheckIcon, ZapIcon } from 'lucide-react';
interface TrustRowProps {
  variant?: 'light' | 'dark';
  guaranteeLabel?: string;
  showAccess?: boolean;
}
export function TrustRow({
  variant = 'light',
  guaranteeLabel = '14-Day Money-Back Guarantee',
  showAccess = true
}: TrustRowProps) {
  const text = variant === 'light' ? 'text-pf-navy' : 'text-white/90';
  const icon = variant === 'light' ? 'text-pf-coral' : 'text-pf-coral';
  return <div className={`flex flex-wrap items-center justify-center gap-x-3 gap-y-0.5 text-[11px] font-bold sm:text-sm ${text}`} data-id="element-245" data-mp="1p1wi812zsi1h">
      {showAccess && <span className="flex items-center gap-1" data-id="element-246" data-mp="1yyrd8a0240b0">
          <ZapIcon className={`h-3.5 w-3.5 ${icon}`} aria-hidden="true" data-id="element-247" data-mp="1tywly5cdd8pf" />
          Immediate Access • Digital Delivery
        </span>}
      <span className="flex items-center gap-1" data-id="element-248" data-mp="3ac3mj0el5b4k">
        <ShieldCheckIcon className={`h-4 w-4 ${icon}`} aria-hidden="true" data-id="element-249" data-mp="3aezkgoqfnzt0" />
        {guaranteeLabel}
      </span>
    </div>;
}